import React from "react";
import loadable from "@loadable/component";
import {showHideLoader} from "../../actions/index";

export default {
	component: loadable(() => import(/* webpackChunkName: "editBrandCategory" */ "./BrandCatHolder"),{
		fallback: <div>Loading...</div>
	})
};
